import styled from 'styled-components';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 60vh;
`;

export default LayoutContainer;
